import React, { useState } from 'react';
import { useSearchExport } from '../context/SearchExportContext';

const ExportDropdown = ({ data, fileName }) => {
    const { exportEmailsAsCSV, exportDataAsCSV, exportDataAsXLSX, searchTerm, setSearchTerm, filterData } = useSearchExport();
    const [isOpen, setIsOpen] = useState(false);

    // Toggle dropdown visibility
    const toggleDropdown = () => setIsOpen(!isOpen);

    // Filtered data based on search term
    const filteredData = filterData(data);

    return (
        <div className="relative flex gap-8 inline-block text-left">
            <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search..."
                className="px-4 py-2 border border-gray-300 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-blue-500 transition duration-300 ease-in-out text-gray-700 placeholder-gray-400 mb-4"
            />

            <div className="relative">
                <button
                    onClick={toggleDropdown}
                    className="w-full py-3 px-12 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg font-semibold text-lg hover:from-blue-600 hover:to-purple-600 transition-all duration-200 ease-in-out transform hover:scale-105"
                >
                    Export Options
                </button>
                {isOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white border rounded-md shadow-lg z-10">
                        <ul className="py-1">
                            <li
                                className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
                                onClick={() => exportEmailsAsCSV(filteredData)}
                            >
                                Export Emails as CSV
                            </li>
                            <li
                                className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
                                onClick={() => exportDataAsCSV(filteredData, fileName)}
                            >
                                Export Data as CSV
                            </li>
                            <li
                                className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
                                onClick={() => exportDataAsXLSX(filteredData, fileName)}
                            >
                                Export as XLSX
                            </li>
                            {/* <li
                                className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
                                onClick={() => exportDataToGoogleSheets(filteredData)}
                            >
                                Export to Google Sheets
                            </li> */}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExportDropdown;